import { render } from "./nav-menu.vue?vue&type=template&id=450fcd75&scoped=true&ts=true"
import script from "./nav-menu.vue?vue&type=script&lang=ts"
export * from "./nav-menu.vue?vue&type=script&lang=ts"

import "./nav-menu.vue?vue&type=style&index=0&id=450fcd75&scoped=true&lang=less"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-450fcd75"]])

export default __exports__